import api from './api';
import { CalendarSponsorship } from '@/types/booking.types';

export class SponsorshipService {
  static async getCalendarSponsorship(calendarId: string, locationId?: string): Promise<CalendarSponsorship | null> {
    try {
      const response = await api.get(`/sponsorships/calendars/${calendarId}`, {
        params: locationId ? { locationId } : undefined,
      });
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 404) return null;
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        'Failed to get calendar sponsorship';
      throw new Error(message);
    }
  }

  static async getCalendarSponsorships(
    calendarIds: string[],
    locationId?: string,
  ): Promise<Record<string, CalendarSponsorship | null>> {
    if (!calendarIds.length) return {};
    try {
      const response = await api.get('/sponsorships/calendars/batch', {
        params: { calendarIds: calendarIds.join(','), ...(locationId ? { locationId } : {}) },
      });
      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        'Failed to get calendar sponsorships';
      throw new Error(message);
    }
  }
}

export default SponsorshipService;
